import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamMonthlyGoalResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
  month?: number;
};

const getTeamMonthlyGoal = async (params: Params): Promise<TeamMonthlyGoalResponse> => {
  const { data } = await api.get<TeamMonthlyGoalResponse>(
    `${BI_BASE_URL}/managers/team/monthly/goal`,
    { params }
  );

  return data;
};

export const useGetTeamMonthlyGoal = ({ year, month }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_MONTHLY_GOAL, year, month],
    queryFn: () => {
      return getTeamMonthlyGoal({ year, month });
    },
  });
};
